import LocalSettingsProto from "../../../../core/gd/settings/local-settings/local-settings-v4";


export default class MenuSectionController_Settings extends LocalSettingsProto {

    public showAllItems : boolean

    constructor(key: string, defaultValue: boolean) {
        super(key);

        const values        = this._readFromLocalStorage();

        this.showAllItems   = _.get(values, 'showAllItems', defaultValue);
    }

    get showAll() {
        return this.showAllItems
    }

    set showAll(value: boolean) {
        this.showAllItems = value
        this.save()
    }


    toObject() {
        return {
            showAllItems: this.showAllItems
        };
    }

}
